import React, { useEffect } from 'react';
import { Route, Routes, BrowserRouter, Navigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import routesMap from 'src/js/router/helpers/routes-map';
import PaywallRoute from 'src/js/router/routes/paywall-route';
import EcommercePaywallRoute from 'src/js/router/routes/ecommerce-paywall-route';
import DomainSelectorRoute from 'src/js/router/routes/domain-selector-route';
import InitiateUpgradeRoute from 'src/js/router/routes/initiate-upgrade-route';
import InitiatePurchaseRoute from 'src/js/router/routes/initiate-purchase-route';
import CancelSubscriptionsRoute from 'src/js/router/routes/cancel-subscriptions-route';
import DashboardRoute from 'src/js/router/routes/dashboard-route';
import AccountManagementPage from 'src/js/modules/account-management/pages/account-management-page';
import ProfilePageContainer from 'src/js/modules/profile/containers/profile-page-container';
import SubscriptionDetailsRoute from 'src/js/modules/account-management/routes/subscription-details-route';
import PageTitleContainer from 'src/js/common/containers/page-title-container';
import DifmPopupContainer from 'src/js/modules/difm/containers/difm-popup-container';
import DifmUpsellRoute from 'src/js/router/routes/difm-upsell-route';
import DialogsContainer from 'src/js/modules/dialogs/containers/dialogs-container';
import ErrorBoundaryContainer from 'src/js/modules/error/containers/error-boundary-container';
import { FeatureFlagsProvider } from 'src/js/modules/feature-flags/context';
import user from './modules/user';
import config from './modules/config';
import { PageContainer } from './common/components/page-container';
import dialogs from './modules/dialogs';
import TagManagerContainer from './modules/analytics/google-tag-manager/containers/tag-manager-container';

function App() {
  const configData = useSelector(config.selectors.getConfig);
  const userData = useSelector(user.selectors.getUserData);
  const isB2C = useSelector(user.selectors.getIsB2C);

  const dispatch = useDispatch();

  useEffect(() => {
    if (configData) {
      const loadingItems = document.querySelectorAll('.js-loading-screen-item');
      if (loadingItems.length > 0) {
        loadingItems.forEach((item) => item.remove());
      }

      if (isB2C && !userData.isLatestUserAgreementAccepted && !userData.employeeId) {
        dispatch(dialogs.actions.show(dialogs.dialogTypes.TERMS_OF_USE_DIALOG));
      }
    }
    // eslint-disable-next-line yola/react-hooks/exhaustive-deps
  }, [configData]);

  if (!configData) return null;

  return (
    <ErrorBoundaryContainer>
      <FeatureFlagsProvider>
        <BrowserRouter>
          <Routes>
            <Route path={routesMap.initiateUpgrade.pattern()} element={<InitiateUpgradeRoute />} />
            <Route
              path={routesMap.initiatePurchase.pattern()}
              element={<InitiatePurchaseRoute />}
            />
            <Route path={routesMap.difmUpsell.pattern()} element={<DifmUpsellRoute />} />
            <Route path={routesMap.paywall.pattern()} element={<PaywallRoute />} />
            <Route
              path={routesMap.ecommercePaywall.pattern()}
              element={<EcommercePaywallRoute />}
            />
            <Route path={routesMap.domainSelector.pattern()} element={<DomainSelectorRoute />} />
            <Route element={<PageContainer />}>
              <Route
                path={routesMap.cancelSubscriptions.pattern()}
                element={<CancelSubscriptionsRoute />}
              />
              <Route
                path={routesMap.subscriptionDetails.pattern()}
                element={<SubscriptionDetailsRoute />}
              />
              <Route
                path={routesMap.accountManagement.pattern()}
                element={<AccountManagementPage />}
              />
              <Route path={routesMap.profile.pattern()} element={<ProfilePageContainer />} />
              <Route path={routesMap.dashboard.pattern()} element={<DashboardRoute />} />
              <Route path={routesMap.home.pattern()} element={<DashboardRoute />} />
              <Route
                path="/sites"
                element={<Navigate to={routesMap.dashboard.pattern()} replace />}
              />
            </Route>
          </Routes>

          <DifmPopupContainer />
          <DialogsContainer />
          <PageTitleContainer />
          <TagManagerContainer />
        </BrowserRouter>
      </FeatureFlagsProvider>
    </ErrorBoundaryContainer>
  );
}

export default App;
